<template>
  <div class="app">
    <div class="header01" v-if="!isMobile">
      <el-menu :default-active="String(activeIndex)" class="el-menu-vertical-demo" @open="handleOpen"
        @close="handleClose">
        <el-menu-item index="1" @click="goToNewjob">
          <i class="el-icon-edit"></i>
          <span slot="title">发布岗位</span>
        </el-menu-item>
        <el-menu-item index="2" @click="goToCvscreening">
          <i class="el-icon-user"></i>
          <span slot="title">推荐人才</span>
        </el-menu-item>
        <el-menu-item index="3" @click="goToDownLoad">
          <i class="el-icon-download"></i>
          <span slot="title">下载的简历</span>
        </el-menu-item>
        <el-menu-item index="4" @click="goToJobList">
          <i class="el-icon-data-analysis"></i>
          <span slot="title">职业发布数据</span>
        </el-menu-item>
        <el-menu-item index="5" @click="goTocorpinfo">
          <i class="el-icon-office-building"></i>
          <span slot="title">企业信息</span>
        </el-menu-item>
        <el-menu-item index="6" @click="goToQiyesystem">
          <i class="el-icon-setting"></i>
          <span slot="title">系统设置</span>
        </el-menu-item>
      </el-menu>
    </div>

    <div class="header01" v-else>
      <el-menu :default-active="String(activeIndex)" class="el-menu-vertical-demo" mode="horizontal"
        @select="handleSelect">
        <el-menu-item index="1" @click="goToNewjob">发布岗位</el-menu-item>
        <el-menu-item index="2" @click="goToCvscreening">推荐人才</el-menu-item>
        <el-menu-item index="3" @click="goToDownLoad">下载的简历</el-menu-item>
        <el-menu-item index="4" @click="goToJobList">职业发布数据</el-menu-item>
        <el-menu-item index="5" @click="goTocorpinfo">企业信息</el-menu-item>
        <el-menu-item index="6" @click="goToQiyesystem">系统设置</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isMobile: false
    }
  },
  name: 'qiyeHeader',
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleSelect(key, keyPath) {
    },
    goToDownLoad() {
      if (this.$route.path !== '/downloadresume') {
        this.$router.push('/downloadresume');
      }
    },
    goToCvscreening() {
      if (this.$route.path !== '/cvscreening') {
        this.$router.push('/cvscreening');
      }
    },
    goToJobList() {
      if (this.$route.path !== '/JobBoard') {
        this.$router.push('/JobBoard');
      }
    },
    goTocorpinfo() {
      if (this.$route.path !== '/corpinfo') {
        this.$router.push('/corpinfo');
      }
    },
    goToUserSystem() {
      if (this.$route.path !== '/usersystem') {
        this.$router.push('/usersystem');
      }
    },
    goToQiyesystem() {
      if (this.$route.path !== '/qiyesystem') {
        this.$router.push('/qiyesystem');
      }
    },
    goToNewjob() {
      if (this.$route.path !== '/newjob') {
        this.$router.push('/newjob');
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  }
}
</script>

<style scoped>
.header01 {
  width: 220px;
}

.el-menu-vertical-demo {
  text-align: left;
  margin-left: 20px;
  height: 87vh;
}

@media (max-width: 768px) {
  .header01 {
    width: 100%;
  }

  .el-menu-vertical-demo {
    margin-left: 0;
    height: auto;
    padding: 10px 0;
  }

  .el-menu-item {
    font-size: 14px;
  }

  .el-menu--horizontal>.el-menu-item {
    height: 35px !important;
    line-height: 35px !important;
  }

  .el-dropdown-menu__item,
  .el-menu-item {
    font-size: 14px;
    padding: 0px 15px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/qiyeHeader.vue